// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Aniversariantes_ListaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Input contract for POST /aniversariantes/lista
 *
 * Scopes the birthday list to the period selected via the global filter
 * (useFiltro DataInicio/DataFim). Replaces the legacy /semana and /mes
 * endpoints, which were tied to page-level filter widgets.
 */
import { registerContract } from './validate'

export interface Aniversariantes_ListaInput {
data_inicio?: string
data_fim?: string
}

registerContract('Aniversariantes_ListaInput', {
  data_inicio: { type: 'string',  required: false },
  data_fim:    { type: 'string',  required: false },
})
